module.exports = __webpack_public_path__ + "static/media/arrivesEarly.c43e073d.png";